import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Caption } from '@alfa-bank/site-caption';
import { ArrowPopover } from '@alfa-bank/site-popover/arrow-popover';
import { IconHint } from '@alfa-bank/site-icon/hint';

import { Title as Component } from './title';
import type { IDeps, IProps } from './models';
import styles from './styles/title.css';

const TitleDesktop = createWidget<IDeps, IProps>({
    ArrowPopover,
    Caption,
    IconHint,
    styles,
})(Component);

const TitleMobile = createWidget<IDeps, IProps>({
    ArrowPopover,
    Caption,
    IconHint,
    size: 's',
    styles,
})(Component);

export { TitleDesktop, TitleMobile };
